import { PlansPlanMode } from '../../../api/types'
import { EventNames } from '../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../utils/appBridge'
import {
  PlansLumpsumListEventIds,
  PlansLumpsumListScreenByPlanMode
} from '../../../../analytics/plansEvents'
import { isListPlansFetchFailed, isListPlansHeaderLoading, useLumpsumPlansContext } from '../../LumpsumPlansProvider'
import { isPlansListFullyEmpty } from '../../../../utils/lumpsum/planListUtils'
import {
  DEFAULT_PLANS_ACTION_FILTERS,
  ListPlansActionFilters,
  LUMPSUM_PLANS_ACTION_FILTERS_CLASS_NAME
} from './ListPlansActionFilters'

export function LumpsumPlansActionFilters() {
  const {
    planMode,
    actionFilter,
    handleActionFilterChange,
    allocationPlansData,
    allocationPlansQuery,
    rebalancePlansData,
    rebalancePlansQuery
  } = useLumpsumPlansContext()

  if (planMode === PlansPlanMode.IDEAL_PORTFOLIO) {
    return null
  }

  const isAllocationMode = planMode === PlansPlanMode.ALLOCATION
  const plansData = isAllocationMode ? allocationPlansData : rebalancePlansData
  const plansQuery = isAllocationMode ? allocationPlansQuery : rebalancePlansQuery
  const isHeaderLoading = isListPlansHeaderLoading(planMode, plansData != null, plansQuery)
  const isPlansEmpty = !isHeaderLoading && isPlansListFullyEmpty(plansData?.categories)
  const isPlansFetchFailed = isListPlansFetchFailed(planMode, plansQuery)

  // Locked top-shape / empty: no sell/buy/under-review to filter.
  if (plansData != null && plansData.isPlanSubscriptionEligible !== true) {
    const sellFundCount = plansData.sellFundCount ?? 0
    const buyFundCount = plansData.buyFundCount ?? 0
    const underReviewFundCount = plansData.underReviewFundCount ?? 0
    if (sellFundCount + buyFundCount + underReviewFundCount === 0) {
      return null
    }
  }

  if (isPlansEmpty || isPlansFetchFailed) {
    return null
  }

  return (
    <div className={LUMPSUM_PLANS_ACTION_FILTERS_CLASS_NAME}>
      <ListPlansActionFilters
        availableFilters={DEFAULT_PLANS_ACTION_FILTERS}
        activeFilter={actionFilter}
        inReviewLabel={isAllocationMode ? 'Sell later' : undefined}
        onFilterChange={(nextFilter) => {
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              ScreenName: PlansLumpsumListScreenByPlanMode?.[planMode],
              eventId: PlansLumpsumListEventIds.ActionFilter,
              buttonLabel: nextFilter
            }
          })
          handleActionFilterChange(nextFilter)
        }}
      />
    </div>
  )
}
